import style from './StageStartModal.module.css';

import Modal from 'ui/Modal';
import Objects from './Objects';
import Resource from './Resource';
import { FormProvider, useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { productionStore } from 'store/mobx/production.store';
import useAlert from 'hooks/useAlert';

const StageStartModal = ({ setOpen, open, node }) => {
  const formContext = useForm();
  const { showAlert } = useAlert();

  const { startProcessIteration } = productionStore;
  const { handleSubmit, reset } = formContext;
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);

  const closeModal = () => setOpen(false);

  const onSubmit = async (data) => {
    setLoader(true);

    const res = await startProcessIteration(node?.id, data);
    if (res.status) {
      closeModal();
    } else showAlert(res.message, 'error');
    setLoader(false);
  };

  return (
    <Modal
      title="Запустить этап производства"
      onClose={closeModal}
      onSubmit={handleSubmit(onSubmit)}
      open={open}
      submitText="Запустить"
      disabledSubmit={loader}
    >
      <FormProvider {...formContext}>
        <div>
          <div className={style.formBody}>
            <Objects objects={node?.objects} />
          </div>
          {node?.resources?.length > 0 && <div className={style.title}>Оборудование</div>}
          {node?.resources.map((resource, index) => {
            return <Resource key={resource.id} resource={resource} index={index} />;
          })}
        </div>
      </FormProvider>
    </Modal>
  );
};

export default StageStartModal;
